import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ButtonOutline from './ButtonOutline.vue'
import { useI18n } from 'vue-i18n'

interface EMITS {
  (e: 'showEdit', val: boolean)
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonEditPoi',
  emits: ["showEdit"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const emits = __emit
function showPoiModal(val: boolean) {
  if (val) emits('showEdit', true)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonOutline, {
    id: "edit-poi",
    iconLeft: require('@/design-system/assets/icons/Icon-Edit.svg'),
    buttonText: _unref(t)('general__text__edit'),
    size: "medium-icon",
    onOnClicked: _cache[0] || (_cache[0] = () => showPoiModal(true))
  }, null, 8, ["iconLeft", "buttonText"]))
}
}

})